import { supabase } from '../config/supabase.js';
export class AddendumService {
    static async createAddendum(data) {
        // Use service client to bypass RLS policies, like other working parts of the codebase
        const { createClient } = await import('@supabase/supabase-js');
        const { getEnvironmentAwareSupabaseUrl, getEnvironmentAwareSupabaseServiceKey } = await import('../config/supabase.js');
        const baseUrl = getEnvironmentAwareSupabaseUrl();
        const serviceKey = getEnvironmentAwareSupabaseServiceKey();
        const serviceClient = createClient(baseUrl, serviceKey, {
            auth: {
                autoRefreshToken: false,
                persistSession: false,
                detectSessionInUrl: false
            }
        });
        const { data: addendum, error } = await serviceClient
            .from('visit_addendums')
            .insert({
            visit_id: data.visit_id,
            provider_id: data.provider_id,
            content: data.content.trim(),
            created_at: new Date().toISOString()
        })
            .select()
            .single();
        if (error) {
            console.error('🚨 ADDENDUM SERVICE ERROR BYPASS TEST 2026-01-11:', error);
            throw new Error(`Failed to create addendum: ${error.message}`);
        }
        return addendum;
    }
    static async getAddendumsByVisitId(visitId) {
        const { data: addendums, error } = await supabase
            .from('visit_addendums')
            .select('*')
            .eq('visit_id', visitId)
            .order('created_at', { ascending: false }); // Most recent first
        if (error) {
            throw new Error(`Failed to get addendums: ${error.message}`);
        }
        return addendums || [];
    }
    static async deleteAddendum(id) {
        const { error } = await supabase
            .from('visit_addendums')
            .delete()
            .eq('id', id);
        if (error) {
            throw new Error(`Failed to delete addendum: ${error.message}`);
        }
    }
    static async getAddendumsByProviderId(providerId) {
        const { data: addendums, error } = await supabase
            .from('visit_addendums')
            .select('*')
            .eq('provider_id', providerId)
            .order('created_at', { ascending: false });
        if (error) {
            throw new Error(`Failed to get provider addendums: ${error.message}`);
        }
        return addendums || [];
    }
}
